// extracted by mini-css-extract-plugin
module.exports = {"content":"chief-balancing-page_content__ziKR9","loader":"chief-balancing-page_loader__32h7a","title":"chief-balancing-page_title__2NPTE"};